//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/** TIDAL button component */
export default {
    props: {
        /**
         * Specifies whether the button is in a loading state. If enabled, the button content changes to an animated
         * TIDAL logo and can't be interacted with.
         */
        loading: {
            type: Boolean,
            default: false,
        },
        /**
         * Needs to be set when wanting to use the `success` state. Set to `true` or to a number. Setting a number
         * changes the delay before the success state is set (the default delay is 1 second). The button will
         * emit a `success` event after the delay.
         */
        willSucceed: {
            type: [Boolean, Number],
            default: false,
        },
        /**
         * Specifies whether the button is in a success state. This requires that `will-succeed` is also set (see its
         * description for more info).
         */
        success: {
            type: Boolean,
            default: false,
        },
        /**
         * Specifies whether the button is in a disabled state. If enabled, the button is visually muted and can't be
         * integrated with.
         */
        disabled: {
            type: Boolean,
            default: false,
        },
        /** The `type` attribute to assign to the internal `button` element. */
        type: {
            type: String,
            default: 'button',
        },
        /** Specifies a link to navigate on clicking. If set, the `click` event is not dispatched on clicking. */
        href: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            width: 8,
            height: 8,
            isClicked: false,
            readySuccess: false,
        };
    },
    computed: {
        /** @return {boolean} */
        isLoading() {
            return (this.isClicked && !this.isSuccess) || this.loading;
        },
        /** @return {boolean} */
        isSuccess() {
            return this.success && this.readySuccess;
        },
    },
    watch: {
        /** @type {import('vue').WatchHandler<boolean>} */
        loading(loading) {
            if (this.willSucceed && !loading) {
                this.isClicked = false;
                this.readySuccess = false;
            }
        },
        /** @type {import('vue').WatchHandler<boolean>} */
        success(success) {
            if (this.willSucceed) {
                if (success) {
                    this.startTimeout();
                } else {
                    this.isClicked = false;
                    this.readySuccess = false;
                }
            }
        },
    },
    methods: {
        startTimeout() {
            if (this.isClicked) {
                return;
            }

            this.isClicked = true;
            const delay = typeof(this.willSucceed) === 'number' && Number.isInteger(this.willSucceed) ? this.willSucceed : 1000;

            setTimeout(() => {
                this.readySuccess = true;
                setTimeout(() => {
                    /** Triggered after success state is set. */
                    this.$emit('success');
                }, delay);
            }, delay);
        },
        /** @param {MouseEvent} event */
        click(event) {
            if (this.loading || this.isClicked) {
                return;
            }

            if (this.href) {
                window.location.href = this.href;
            } else {
                /** Triggered on button click. Doesn't trigger when `href` is set. */
                this.$emit('click', event);
            }
        },
    },
};
